import React from 'react';
import { AccountLoginRegistration } from 'components/AccountLoginRegistration';
import classNames from 'classnames';

import styles from './styles.module.scss';

const letters = ['A', 'E', 'M', 'L', 'D', 'S', 'C', 'S', 'P', 'T', 'D', 'S', 'T', 'A', 'U', 'P'];

/**
 * Creates the signin prompt for the word search game. It should show
 * the gate or the account login flow based on feature flags.
 * @returns {React.ReactElement} - The rendered signin prompt
 */
export function SignInPrompt() {
  return (
    <div className={styles.container} data-testid="word-search-game--sign-in-prompt">
      <div className={classNames(styles.overlay, styles.accountLoginOverlay)}>
        <div className={styles.letters}>
          {letters.map((letter, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <span key={index}>{letter}</span>
          ))}
        </div>
      </div>
      <AccountLoginRegistration />
    </div>
  );
}
